/* Custom shades need manufacturing specifications, not just a price-tier variant. */
(function () {
  'use strict';
  if (window.ervpShadeSpecGuard) return;
  var catalog = JSON.parse(document.getElementById('ervp-shade-spec-catalog').textContent);
  var variants = Object.create(null);
  catalog.forEach(function (p) { p.variants.forEach(function (id) { variants[String(id)] = p; }); });
  var originalFetch = window.fetch.bind(window);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function value(props, names) {
    for (var i = 0; i < names.length; i++) {
      var v = props[names[i]];
      if (v != null && String(v).trim()) return String(v).trim();
    }
    return '';
  }
  function dimension(v) {
    // Existing builders use decimals, ASCII fractions, or Unicode quarter marks.
    return /^\d+(?:\.\d+)?(?:\s*(?:[¼½¾]|[1-3]\/[24]))?\s*(?:["″]|in(?:ches)?)?$/i.test(v) && parseFloat(v) > 0;
  }
  function inspect(item) {
    var product = variants[String(item.variant_id || item.id)];
    if (!product || Number(item.quantity) === 0) return null;
    var props = item.properties || {};
    if (Array.isArray(props)) props = Object.fromEntries(props.map(function (p) { return [p.name, p.value]; }));
    var missing = [];
    if (!dimension(value(props, ['Width', 'Exact Width']))) missing.push('exact width');
    if (!dimension(value(props, ['Height', 'Exact Height']))) missing.push('exact height');
    if (!value(props, ['Night Shade Color', 'Fabric Color', 'Color', 'Night Fabric Color'])) missing.push(product.dayNight ? 'night fabric color' : 'fabric color');
    if (product.dayNight && !value(props, ['Day Shade Color', 'Day Fabric Color'])) missing.push('day fabric color');
    if (!value(props, ['Top & Pull Rail Color', 'Rail Color', 'Top Rail Color'])) missing.push('rail color');
    return missing.length ? {product: product, missing: missing} : null;
  }
  function problem(payload) {
    var items = payload && (payload.items || [payload]);
    if (!items) return null;
    return items.map(inspect).find(Boolean) || null;
  }
  function message(issue) { return 'Please configure this custom shade before purchasing. Missing: ' + issue.missing.join(', ') + '.'; }
  function notice(issue) {
    if (!document.body) { document.addEventListener('DOMContentLoaded', function () { notice(issue); }, {once:true}); return; }
    var box = document.getElementById('ervp-shade-spec-error');
    if (!box) {
      box = document.createElement('div'); box.id = 'ervp-shade-spec-error';
      box.setAttribute('role', 'alert'); box.tabIndex = -1;
      box.style.cssText = 'position:fixed;bottom:18px;left:12px;right:12px;max-width:620px;margin:auto;padding:18px;background:#fff8eb;border:2px solid #895100;border-radius:8px;box-shadow:0 3px 16px #0003;color:#292929;z-index:2147483000';
      document.body.appendChild(box);
    }
    box.replaceChildren();
    var text = document.createElement('p'); text.textContent = message(issue); box.appendChild(text);
    var link = document.createElement('a'); link.href = root + 'products/' + issue.product.handle;
    link.textContent = 'Configure size and colors'; link.style.cssText = 'font-weight:bold;text-decoration:underline;margin-right:20px'; box.appendChild(link);
    var close = document.createElement('button'); close.type = 'button'; close.textContent = 'Close'; close.onclick = function () { box.remove(); }; box.appendChild(close);
    box.focus();
  }
  function parse(body) {
    if (!body) return null;
    if (typeof body === 'string') { try { return JSON.parse(body); } catch (_) { body = new URLSearchParams(body); } }
    if (!(body instanceof FormData) && !(body instanceof URLSearchParams)) return null;
    var payload = {properties: {}};
    body.forEach(function (v, key) {
      var prop = /^properties\[(.+)\]$/.exec(key);
      var nested = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(key);
      var nestedProp = /^items\[(\d+)\]\[properties\]\[(.+)\]$/.exec(key);
      if (prop) payload.properties[prop[1]] = v;
      else if (nested || nestedProp) {
        var match = nested || nestedProp;
        payload.items = payload.items || [];
        var row = payload.items[Number(match[1])] || (payload.items[Number(match[1])] = {properties:{}});
        if (nested) row[match[2]] = v; else row.properties[match[2]] = v;
      } else payload[key] = v;
    });
    return payload;
  }
  function isAdd(url) { try { var u = new URL(url, location.href); return u.origin === location.origin && /\/cart\/add(?:\.js|\.json)?\/?$/.test(u.pathname); } catch (_) { return false; } }
  window.fetch = async function (input, init) {
    var url = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
    if (isAdd(url)) {
      var body = init && init.body;
      if (!body && input instanceof Request) body = await input.clone().text();
      var issue = problem(parse(body));
      if (issue) {
        notice(issue);
        return new Response(JSON.stringify({status:422,message:message(issue),description:message(issue)}), {status:422,headers:{'Content-Type':'application/json'}});
      }
    }
    return originalFetch(input, init);
  };
  var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this.ervpShadeAdd = isAdd(url); return open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    var issue = this.ervpShadeAdd && problem(parse(body));
    if (issue) { notice(issue); this.abort(); this.dispatchEvent(new Event('error')); this.dispatchEvent(new Event('loadend')); return; }
    return send.apply(this, arguments);
  };
  function protectForm(event) {
    var target = event.target instanceof Element ? event.target : null;
    var button = target && target.closest('button,input[type="submit"]');
    if (event.type === 'click' && (!button || (button.type !== 'submit' && button.dataset.action !== 'add-to-cart'))) return;
    var form = event.type === 'submit' ? target : button && button.form;
    if (!form || !isAdd(form.action)) return;
    var issue = problem(parse(new FormData(form)));
    if (issue) { event.preventDefault(); event.stopImmediatePropagation(); notice(issue); }
  }
  document.addEventListener('click', protectForm, true);
  document.addEventListener('submit', protectForm, true);
  var checking = false, approved = null;
  async function protectCheckout(event) {
    var target = event.target instanceof Element ? event.target : null;
    var form = event.type === 'submit' && target;
    var control = form ? event.submitter : target && target.closest('a[href],button[name="checkout"],input[name="checkout"],shopify-accelerated-checkout-cart');
    var href = control && control.getAttribute('href');
    var isCheckoutLink = href && /\/checkout(?:[/?#]|$)/.test(href);
    if (!(control && (control.name === 'checkout' || isCheckoutLink || control.matches('shopify-accelerated-checkout-cart'))) && !(form && /\/checkout(?:[/?#]|$)/.test(form.action))) return;
    if (approved === control || approved === form) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    try {
      var response = await originalFetch(root + 'cart.js', {cache:'no-store'});
      if (!response.ok) throw Error('Cart unavailable');
      var cart = await response.json(), issue = problem(cart);
      if (issue) { notice(issue); return; }
      if (isCheckoutLink) location.assign(href);
      else if (form) { approved = control || form; form.requestSubmit(control || undefined); approved = null; }
      else if (control.name === 'checkout') { approved = control; control.click(); approved = null; }
      else location.assign(root + 'checkout');
    } catch (_) { alert('Your cart could not be checked. Please reload the cart and try again.'); }
    finally { checking = false; }
  }
  document.addEventListener('click', protectCheckout, true);
  document.addEventListener('submit', protectCheckout, true);
  function protectBundles() {
    document.querySelectorAll('essential-upsell-frequently-bought-together-app-block,essential-upsell-cross-sell-app-block').forEach(function (host) {
      if (host.dataset.ervpShadeProtected) return;
      var found = catalog.filter(function (p) { return Array.from(host.querySelectorAll('a[href]')).some(function (a) { return a.pathname === root + 'products/' + p.handle; }); });
      if (!found.length) return;
      host.dataset.ervpShadeProtected = 'true'; host.hidden = true; host.style.setProperty('display','none','important');
      var box = document.createElement('div'); box.className = 'ervp-shade-configure-links';
      box.style.cssText = 'padding:14px;margin:14px 0;border:1px solid #d8d8d8;border-radius:6px';
      var title = document.createElement('p'); title.textContent = 'Custom shades need exact dimensions and colors. Configure each shade before adding it to your cart.'; box.appendChild(title);
      found.forEach(function (p) { var a = document.createElement('a'); a.href = root + 'products/' + p.handle; a.textContent = 'Configure ' + p.title; a.style.cssText = 'display:block;text-decoration:underline;margin:8px 0'; box.appendChild(a); });
      host.insertAdjacentElement('afterend',box);
    });
  }
  function ready() {
    protectBundles();
    var scheduled = false;
    new MutationObserver(function () { if (!scheduled) { scheduled = true; requestAnimationFrame(function () { scheduled = false; protectBundles(); }); } }).observe(document.body,{childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',ready); else ready();
  window.ervpShadeSpecGuard = {inspect:inspect,version:'2026-09-15'};
})();
